import React, { Component } from 'react'
import { FullHeightRow, SpacedCol, FullHeightGrid, Button, context, LoginForm } from '@tools/wr-catalog-base'

class LoginView extends Component {
  handleLogin = () => {
    window.location.href = `${context.constants.host}/beta/sso/saml-sso-redirect`
  }

  render() {
    const bodyEl = window.document.getElementsByTagName('body')[0]
    bodyEl.className = 'login-page'
    const loginBox = window.document.getElementsByClassName('loginBox')[0]
    if (loginBox) {
      loginBox.style.display = 'none'
    }

    return (
      <FullHeightGrid fluid>
        <FullHeightRow middle="xs" center="xs">
          <SpacedCol className="login-page-form-spacer" lg={3} md={6} sm={9} xs={12}>
            {context.constants.isSsoDisabled ? <LoginForm /> : <Button onClick={this.handleLogin}>Login</Button>}
          </SpacedCol>
        </FullHeightRow>
      </FullHeightGrid>
    )
  }
}

export default LoginView
